import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import Category from './Category/Category'

const defaultstate = true

const AdvacnedSearchBlock = (props) => {    

    const [showcategory, setShowcategory] = useState({
        visible: true
    })

    const [resdata, setResdata] = useState({
        categoriesdata: []
    })
    const [categories, setCategories] = useState([])
    
    useEffect(() => {
        setCategories(props.categories)
    })
    
    useEffect(() => {         
        if(!props.selectState){
            setResdata({
                categoriesdata:[]
            })                        
        }
    }, [props.selectState])

    const updateresult = (data, category) => {
        if(!resdata.categoriesdata.includes(data))                
            return setResdata({ ...resdata, categoriesdata: [...resdata.categoriesdata, data] });
        else 
            return setResdata({ ...resdata, categoriesdata: [...resdata.categoriesdata.filter(item => item !== data)] });
    }

    useEffect(() => {
        props.fetchdata(resdata,'advsearch')
    }, [resdata])

    const showMenuHandler = (e) => {
        e.preventDefault()
        if (e.target.id === 'categorymenu') {
            showcategory.visible ?
            setShowcategory({ ...showcategory, visible: false }) :
            setShowcategory({ ...showcategory, visible: true })
        }
    }

    const { t } = props;

    return (
        <div className="advsearchblk">
            <div className="categoryheader">
                <h2>{t('RecipeFinder_Category')}</h2>
                <button className="btn btn-link">
                    <i 
                        className={`${showcategory.visible ? 'fa fa-angle-down' : 'fa fa-angle-up'}`}
                        aria-hidden="true" 
                        id="categorymenu" 
                        onMouseDown={(event) => showMenuHandler(event)}
                        //onClick={(event) => showMenuHandler(event)}  
                    ></i>
                </button>
                {/* <a href="" className="btn btn-link" onClick={(event)=>showMenu(event)}>
                    <i className={`${showcategory ? 'fa fa-angle-down' : 'fa fa-angle-up'}`} aria-hidden="true"></i>
                </a> */}
            </div>
            {
                showcategory.visible && 
                (
                    <div className="categorywrapper">
                        {
                            categories.map((category, index) => {
                                return <Category 
                                            key={index}
                                            title={category.fields.groupName.value}
                                            category={category.displayName}
                                            choices={category.fields.filters} 
                                            icon={category.fields.groupIcon.value}
                                            updateresult={updateresult}
                                            {...props}
                                        />
                            })
                        }
                        <div className='blk blk-btn'>
                        <button className="clear-btn" onClick={props.clearfields}>{t('RecipeFinder_ClearAll')}</button>
                        <input 
                            type="submit"
                            id="name-search-button" 
                            className="btn btn-p"
                            value={t('RecipeFinder_SearchRecipe')}
                            disabled={!props.selectState}
                            onSubmit={props.searchrecipe}
                            onClick={props.searchrecipe}                            
                        />
                        </div>
                    </div>
                )                
            }
        </div>
    );
}

export default withTranslation()(AdvacnedSearchBlock);